export default function RecipeHeader({ recept, steps, bomItems, isDark, jednotky, onPatchRecept }) {
    // Jednotky dávky — jen základní + sekundární jednotky receptu
    const allowedUnitIds = new Set();
    if (recept?.jednotka_id) allowedUnitIds.add(recept.jednotka_id);
    (recept?.alt_jednotky || []).forEach(a => { const id = a.jednotka_do_id || a.jednotka_do?.id; if (id) allowedUnitIds.add(id); });
    const allowedUnits = jednotky.filter(j => allowedUnitIds.has(j.id));

    const inputStyle = {
        background: isDark ? 'rgba(255,255,255,0.06)' : 'var(--surface-base)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)'}`,
        color: 'var(--text-primary)', borderRadius: 6,
        padding: '4px 8px', fontSize: 13, outline: 'none',
        colorScheme: isDark ? 'dark' : 'light',
    };

    const secondaryColor = isDark ? 'rgba(255,255,255,0.5)' : 'var(--text-secondary)';
    const mutedColor = isDark ? 'rgba(255,255,255,0.3)' : 'var(--text-muted)';

    return (
        <div className="mb-4">
            {/* Dávka */}
            <div className="flex items-center gap-2">
                <span className="text-xs font-medium" style={{ color: secondaryColor }}>Dávka</span>
                <input type="number" min="0.01" step="any"
                    value={recept?.pocet_porci || 1}
                    onChange={e => onPatchRecept({ pocet_porci: parseFloat(e.target.value) || 1 })}
                    style={{ ...inputStyle, width: 64, textAlign: 'center' }} />
                <select value={recept?.jednotka_id || ''}
                    onChange={e => onPatchRecept({ jednotka_id: parseInt(e.target.value) })}
                    style={{ ...inputStyle, cursor: 'pointer', width: 70 }}>
                    {allowedUnits.length === 0 && <option value="" style={{ background: isDark ? '#1e1e2e' : '#fff' }}>—</option>}
                    {allowedUnits.map(j => (
                        <option key={j.id} value={j.id} style={{ background: isDark ? '#1e1e2e' : '#fff', color: isDark ? '#e2e8f0' : '#1e293b' }}>
                            {j.zkratka}
                        </option>
                    ))}
                </select>
                <span className="text-xs" style={{ color: mutedColor }}>z jedne vyroby</span>
            </div>
        </div>
    );
}
